<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM8.18164 16.7051C7.61688 16.7052 7.15918 17.1628 7.15918 17.7275C7.1593 22.0106 10.5899 25.5683 15 25.5684C19.2935 25.5683 22.8407 22.021 22.8408 17.7275C22.8408 17.1628 22.383 16.7053 21.8184 16.7051H8.18164ZM20.7002 18.75C20.2071 21.4385 17.8154 23.5233 15 23.5234C12.0982 23.5234 9.77116 21.4454 9.29492 18.75H20.7002Z"
      fill="#040A34"
    />
  </svg>
</template>
